import React from 'react';
import { BookingButton } from '../components/BookingButton';
export function Masterclass() {
  return <div className="w-full min-h-screen bg-[#F1F5F9] overflow-x-hidden pt-20" data-id="element-496" data-mp="2i4tufpw9odzf">
      {/* SECTION 1 — HERO EVENIMENT */}
      <section className="w-full bg-[#09111F] relative overflow-hidden py-20 md:py-32" data-id="element-497" data-mp="2ddc2frc81nql">
        <div className="absolute inset-0 opacity-[0.03] bg-[radial-gradient(#ffffff_1px,transparent_1px)] [background-size:24px_24px]" data-id="element-498" data-mp="28einduhadoob"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#1D4ED8] opacity-10 blur-[150px] rounded-full pointer-events-none" data-id="element-499" data-mp="24bvpbbu0v7io"></div>
        <div className="max-w-[1200px] mx-auto px-5 md:px-12 relative z-10" data-id="element-500" data-mp="1ugat5ubmx1gu">
          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-501" data-mp="1phr61qlb1jmw">
            <div data-id="element-502" data-mp="3otjugyu11go0">
              <div className="inline-flex items-center gap-2 bg-[rgba(255,255,255,0.03)] border border-[rgba(255,255,255,0.08)] backdrop-blur-sm px-4 py-2 rounded-full mb-6" data-id="element-503" data-mp="3ou22sttyrlca">
                <div className="w-2 h-2 rounded-full bg-[#EF4444] animate-pulse" data-id="element-504" data-mp="zwloi654kmcc"></div>
                <span className="font-['Montserrat'] text-[11px] font-bold tracking-[0.18em] uppercase text-white" data-id="element-505" data-mp="zyolja4p3fqk">
                  MASTERCLASS ONLINE GRATUIT
                </span>
              </div>
              <h1 className="font-['Montserrat'] text-[clamp(36px,5vw,56px)] font-extrabold text-white leading-[1.1] mb-6" data-id="element-506" data-mp="ux93lqxtdpce">
                Cele 3 Blocaje Invizibile Care Îți Țin Afacerea pe Loc și Cum le
                Repari în 90 de Zile
              </h1>
              <p className="font-['Inter'] text-[19px] md:text-[22px] font-light text-[rgba(255,255,255,0.8)] leading-[1.6] mb-10" data-id="element-507" data-mp="1nldc0k7rsgis">
                Pentru antreprenori cu echipă care muncesc la fel de mult ca
                acum 2 ani dar afacerea nu mai crește. Descoperă exact ce
                component din business-ul tău sabotează creșterea și care sunt
                primii pași concreți ca să ieși din plafonare.
              </p>

              <div className="bg-[rgba(255,255,255,0.05)] border border-[rgba(255,255,255,0.1)] rounded-2xl p-6 mb-10 flex flex-wrap gap-6 md:gap-10" data-id="element-508" data-mp="2g84mrpftqovg">
                <div data-id="element-509" data-mp="2b9te3i19mket">
                  <p className="font-['Inter'] text-[13px] text-[rgba(255,255,255,0.5)] uppercase tracking-wider mb-1" data-id="element-510" data-mp="2b7747bqwjstf">
                    Data și ora
                  </p>
                  <p className="font-['Montserrat'] text-[16px] font-bold text-white" data-id="element-511" data-mp="2283li8vndffg">
                    Se anunță în curând
                  </p>
                </div>
                <div data-id="element-512" data-mp="1sik1gzw77fj0">
                  <p className="font-['Inter'] text-[13px] text-[rgba(255,255,255,0.5)] uppercase tracking-wider mb-1" data-id="element-513" data-mp="1si0lhoq3z17m">
                    Platforma
                  </p>
                  <p className="font-['Montserrat'] text-[16px] font-bold text-white" data-id="element-514" data-mp="1jiwzoczk47pf">
                    Online, pe Zoom
                  </p>
                </div>
                <div data-id="element-515" data-mp="1ekvgzt61maeh">
                  <p className="font-['Inter'] text-[13px] text-[rgba(255,255,255,0.5)] uppercase tracking-wider mb-1" data-id="element-516" data-mp="19jei2374cy0j">
                    Durata
                  </p>
                  <p className="font-['Montserrat'] text-[16px] font-bold text-white" data-id="element-517" data-mp="3l9npsu87muo2">
                    90 minute
                  </p>
                </div>
                <div data-id="element-518" data-mp="3v6sfv556faa5">
                  <p className="font-['Inter'] text-[13px] text-[rgba(255,255,255,0.5)] uppercase tracking-wider mb-1" data-id="element-519" data-mp="3v68tnc8htzqb">
                    Preț
                  </p>
                  <p className="font-['Montserrat'] text-[16px] font-bold text-[#3B82F6]" data-id="element-520" data-mp="32huv8vdht1e8">
                    GRATUIT
                  </p>
                </div>
              </div>

              <BookingButton text="Înscrie-te GRATUIT la Masterclass" href="#oferta" className="px-10 py-5 text-[16px] mb-3 inline-block" data-id="element-521" data-mp="3bgyga4w7zqvd" />
              <p className="font-['Inter'] text-[13px] text-[rgba(255,255,255,0.5)]" data-id="element-522" data-mp="3g9roj2qwdhc7">
                Locurile sunt limitate. Masterclass-ul este live, nu
                înregistrat. Primești înregistrarea doar dacă te înscrii.
              </p>
            </div>
            <div className="relative hidden md:block" data-id="element-523" data-mp="24mhhvu8yspip">
              <div className="absolute inset-0 bg-[#1D4ED8] opacity-20 blur-[60px] rounded-full" data-id="element-524" data-mp="24kxzny3r04ea"></div>
              <img src="https://images.unsplash.com/photo-1552664730-d307ca884978?q=80&w=2070&auto=format&fit=crop" alt="Masterclass" className="relative z-10 w-full rounded-2xl border-2 border-[rgba(255,255,255,0.1)] shadow-2xl object-cover aspect-[4/5]" data-id="element-525" data-mp="1zmcztzsermqd" />
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 2 — PROBLEMA */}
      <section className="w-full bg-white py-16 md:py-24" data-id="element-526" data-mp="2idnpyeqb7vh7">
        <div className="max-w-[800px] mx-auto px-5 md:px-12 text-center" data-id="element-527" data-mp="2xboe2mky530s">
          <div className="bg-[#F1F5F9] rounded-3xl p-8 md:p-12 border border-[rgba(0,0,0,0.04)] mb-12" data-id="element-528" data-mp="2x9vflukhlp3v">
            <h2 className="font-['Montserrat'] text-[32px] md:text-[40px] font-bold text-[#09111F] mb-8" data-id="element-529" data-mp="2sb0ps8o3r0a9">
              De ce muncești atât de mult și afacerea tot nu crește?
            </h2>
            <div className="space-y-6 font-['Inter'] text-[19px] font-light text-[#4B5563] leading-[1.8] text-left" data-id="element-530" data-mp="y0x3fqkmk6l3">
              <p data-id="element-531" data-mp="3elagkwfc237l">
                Te trezești cu telefonul plin de mesaje de la echipă. Încă nu ai
                ieșit din pat și deja rezolvi o urgență.
              </p>
              <p data-id="element-532" data-mp="2zw4birttdirs">
                Ajungi la birou și petreci toată ziua în întâlniri, aprobări și
                decizii care ar fi trebuit să le ia altcineva.
              </p>
              <p data-id="element-533" data-mp="2quwjuslszg6o">
                Seara ajungi acasă epuizat și te întrebi ce ai construit de fapt
                azi. Răspunsul e aproape mereu același: nimic strategic.
              </p>
              <p data-id="element-534" data-mp="2gytms15t67ql">
                Ai încercat să delegi, dar echipa tot vine la tine pentru
                fiecare decizie. Parcă nu au încredere. Sau poate tu nu ai
                încredere în ei.
              </p>
              <p data-id="element-535" data-mp="f6oq6cdd6m9j">
                Te uiți la cifre și nu înțelegi de ce nu cresc proporțional cu
                efortul pe care îl depui. Ceva nu se leagă.
              </p>
              <p data-id="element-536" data-mp="ip46kxtkmfyu">
                Și cel mai dureros: simți că ideea ta de antreprenoriat, aceea
                care trebuia să îți dea timp, libertate și bani, ți-a dat exact
                opusul.
              </p>
              <p className="font-medium text-[#09111F] p-6 bg-white rounded-2xl border-l-4 border-[#1D4ED8] shadow-sm" data-id="element-537" data-mp="8qez7yzawdwu">
                Nu ești singur în situația asta. Majoritatea antreprenorilor cu
                echipă ajung exact aici. Am fost și eu acolo. De aceea am
                construit ProVi System și de aceea am creat acest masterclass
                gratuit la care te invit și pe tine.
              </p>
            </div>
          </div>
          <BookingButton text="Înscrie-te GRATUIT la Masterclass" href="#oferta" className="px-10 py-5 text-[16px] mb-3 inline-block" data-id="element-538" data-mp="mq7odpv6im2p" />
          <p className="font-['Inter'] text-[13px] text-[#6B7280]" data-id="element-539" data-mp="1k5ttuw41etos">
            Locurile sunt limitate. Masterclass-ul este live, nu înregistrat.
          </p>
        </div>
      </section>

      {/* SECTION 3 — CE VEI DESCOPERI */}
      <section className="w-full bg-[#F1F5F9] py-16 md:py-24" data-id="element-540" data-mp="1npc869fzhq3i">
        <div className="max-w-[800px] mx-auto px-5 md:px-12" data-id="element-541" data-mp="1rpcmlu3321ak">
          <div className="text-center mb-16" data-id="element-542" data-mp="1wn4p1i1ct5t0">
            <h2 className="font-['Montserrat'] text-[32px] md:text-[40px] font-bold text-[#09111F] mb-4" data-id="element-543" data-mp="1wm33ukqmj2xk">
              Ce descoperi concret în cele 90 de minute de masterclass
            </h2>
          </div>
          <div className="flex flex-col gap-4 mb-12" data-id="element-544" data-mp="26llluvmz4emz">
            {['Vei înțelege de ce efortul tău zilnic nu produce creștere și care din cele 8 componente ale afacerii tale sabotează tot restul fără să îți dai seama.', 'Afli cele 3 blocaje invizibile care țin pe loc 80% din companiile românești cu echipă: lipsa viziunii comunicate, roluri confuze și conducere pe feeling în loc de cifre.', 'Descoperi cum funcționează ProVi System: cele 8 componente ale unui business care merge fără antreprenor și în ce ordine se implementează pentru rezultate în 90 de zile.', 'Înveți un exercițiu practic pe care îl faci chiar în masterclass: îți evaluezi propria afacere pe cele 8 componente și identifici blocajul tău principal pe loc.', 'Afli exact ce faci în primele 2 săptămâni după masterclass ca să începi să spargi plafonul, fără investiție financiară, doar cu ce ai deja în compania ta.', 'Primești răspunsuri la întrebările tale specifice în sesiunea de Q&A live cu Valer. Nu întrebări generice. Întrebări despre afacerea ta reală.'].map((item, i) => <div key={i} className="bg-white p-6 rounded-2xl shadow-[0_4px_20px_rgba(0,0,0,0.04)] border border-[rgba(0,0,0,0.04)] flex gap-4 items-start" data-id="element-545" data-mp="2rxbz3zbewwre" data-mpi={i}>
                <div className="w-6 h-6 rounded-full bg-[#1D4ED8] text-white flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-546" data-mp="35q9zk02ppf1t">
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-547" data-mp="2d7ml33i80y9p">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-548" data-mp="2892tonkuyu9y" />
                  </svg>
                </div>
                <p className="font-['Inter'] text-[17px] text-[#4B5563] leading-[1.6]" data-id="element-549" data-mp="np7f73585h9c">
                  {item}
                </p>
              </div>)}
          </div>
          <div className="text-center" data-id="element-550" data-mp="eqvl2r55g1c5">
            <BookingButton text="Înscrie-te GRATUIT la Masterclass" href="#oferta" className="px-10 py-5 text-[16px] mb-3 inline-block" data-id="element-551" data-mp="erx3xhseps4f" />
            <p className="font-['Inter'] text-[13px] text-[#6B7280]" data-id="element-552" data-mp="17f167f047sci">
              90 de minute care pot schimba modul în care îți conduci afacerea.
              GRATUIT.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 4 — CE SE SCHIMBĂ DUPĂ MASTERCLASS */}
      <section className="w-full bg-white py-16 md:py-24" data-id="element-553" data-mp="12folp0wpuxd3">
        <div className="max-w-[1200px] mx-auto px-5 md:px-12" data-id="element-554" data-mp="12e3qd92kvae6">
          <h2 className="font-['Montserrat'] text-[32px] md:text-[40px] font-bold text-[#09111F] mb-12 text-center" data-id="element-555" data-mp="3i6je8208ucgx">
            Cu ce pleci după masterclass
          </h2>
          <div className="grid md:grid-cols-3 gap-8" data-id="element-556" data-mp="32m1ce978pvkq">
            {[{
            title: 'Claritate asupra blocajului real',
            desc: 'Nu mai ghicești ce nu merge. Știi exact care componentă din afacerea ta trebuie reparată prima și de ce tot ce ai încercat până acum nu a funcționat fără asta.'
          }, {
            title: 'Un plan pe care îl poți aplica singur',
            desc: 'Nu pleci doar cu informații. Pleci cu un exercițiu completat pe afacerea ta reală și cu pașii concreți pe care îi faci în primele 2 săptămâni fără nicio investiție.'
          }, {
            title: 'Limba comună cu echipa ta',
            desc: "Înveți un mod simplu de a explica echipei tale ce nu funcționează, pe cifre și pe componente clare, în loc de discuții vagi despre 'trebuie să ne organizăm mai bine'."
          }].map((benefit, i) => <div key={i} className="bg-[#F1F5F9] rounded-2xl p-8 border border-[rgba(0,0,0,0.04)] text-center" data-id="element-557" data-mp="870qef37nf6s" data-mpi={i}>
                <div className="w-14 h-14 bg-white rounded-xl flex items-center justify-center mb-6 text-[#1D4ED8] shadow-sm mx-auto" data-id="element-558" data-mp="d4k3hbo69lx5">
                  <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-559" data-mp="1xks0wwfjs4zx">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" data-id="element-560" data-mp="1sm6yqrgqjb8u"></path>
                  </svg>
                </div>
                <h3 className="font-['Montserrat'] text-[20px] font-bold text-[#09111F] mb-4" data-id="element-561" data-mp="22kmlki8qbycj">
                  {benefit.title}
                </h3>
                <p className="font-['Inter'] text-[16px] text-[#4B5563] leading-[1.6]" data-id="element-562" data-mp="2bf118lx69aw6">
                  {benefit.desc}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* SECTION 5 — CINE SUNT EU */}
      <section className="w-full bg-[#0A1628] py-16 md:py-24 text-white" data-id="element-563" data-mp="2ld8eatocb8sw">
        <div className="max-w-[1200px] mx-auto px-5 md:px-12" data-id="element-564" data-mp="vyshis39ba9r">
          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-565" data-mp="qyo1122cmfjj">
            <div className="relative" data-id="element-566" data-mp="r0ijm9q5dvkg">
              <div className="absolute inset-0 bg-[#1D4ED8] opacity-20 blur-[60px] rounded-full" data-id="element-567" data-mp="1gn36xo9g253j"></div>
              <img src="https://cdn.magicpatterns.com/uploads/fWFHPTDBhfM1RiRRjS7QNx/Valer_1.jpg" alt="Valer Dura" className="relative z-10 w-full max-w-[450px] mx-auto rounded-2xl border-2 border-[rgba(255,255,255,0.1)] shadow-2xl object-cover" data-id="element-568" data-mp="1knvg6hibg9zt" />
            </div>
            <div data-id="element-569" data-mp="1uki0n56qcz1b">
              <h2 className="font-['Montserrat'] text-[32px] md:text-[40px] font-bold mb-8 text-left" data-id="element-570" data-mp="1zlntd30e4mau">
                Cine este Valer Dura și de ce merită să îi dedici 90 de minute
              </h2>
              <div className="space-y-6 font-['Inter'] text-[19px] font-light text-[rgba(255,255,255,0.8)] leading-[1.8] text-left mb-12" data-id="element-571" data-mp="28dzmiwmw2nui">
                <p data-id="element-572" data-mp="2dc14fe8kwh4e">
                  Sunt Valer Dura. Am construit, eficientizat și vândut
                  propriile afaceri cu cifre de milioane de euro. De 12 ani
                  lucrez direct cu antreprenori și echipe de lideri din companii
                  românești și am ajutat zeci de antreprenori să iasă din haosul
                  operațional și să construiască afaceri care funcționează cu
                  sistem.
                </p>
                <p data-id="element-573" data-mp="1pqv9b6gmpyf">
                  Nu sunt un speaker motivațional. Nu predau teorie pe care am
                  citit-o din cărți. Tot ce prezint în acest masterclass vine
                  din experiența directă de a fi construit companii, de a fi
                  avut o echipă care nu funcționa, de a fi trecut prin plafonare
                  și de a fi găsit soluția care funcționează de fiecare dată.
                </p>
                <p data-id="element-574" data-mp="kntflco2bypw">
                  Am creat ProVi System ca răspuns la problema pe care am
                  văzut-o la sute de antreprenori: oameni care muncesc enorm,
                  care au potențial, care au echipă, dar care nu au un sistem.
                  Și fără sistem, creșterea se oprește.
                </p>
                <p className="font-medium text-white border-l-4 border-[#3B82F6] pl-6 py-2" data-id="element-575" data-mp="18cmenhzzemoq">
                  Acest masterclass gratuit este cel mai rapid mod de a înțelege
                  unde ești tu acum, ce te blochează și ce poți face în
                  următoarele 90 de zile ca să schimbi modul în care
                  funcționează afacerea ta.
                </p>
              </div>
              <BookingButton text="Înscrie-te GRATUIT la Masterclass" href="#oferta" className="px-10 py-5 text-[16px] mb-3 inline-block" data-id="element-576" data-mp="nxl47urkoka6" />
              <p className="font-['Inter'] text-[13px] text-[rgba(255,255,255,0.5)]" data-id="element-577" data-mp="1glqpcimjgbaj">
                Locurile sunt limitate de capacitatea Zoom.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 6 — PENTRU CINE ESTE / NU ESTE */}
      <section className="w-full bg-white py-16 md:py-24" data-id="element-578" data-mp="16tuee6zcsqow">
        <div className="max-w-[1000px] mx-auto px-5 md:px-12" data-id="element-579" data-mp="1ukgmfy9cyayw">
          <div className="grid md:grid-cols-2 gap-8" data-id="element-580" data-mp="1zbye1vphqz77">
            <div className="bg-[#EFF6FF] rounded-3xl p-8 border border-[rgba(59,130,246,0.2)]" data-id="element-581" data-mp="1zdsyza0rirba">
              <h3 className="font-['Montserrat'] text-[24px] font-bold text-[#09111F] mb-6 flex items-center gap-3" data-id="element-582" data-mp="3k12i69cj8pmi">
                <div className="w-8 h-8 rounded-full bg-[#1D4ED8] text-white flex items-center justify-center" data-id="element-583" data-mp="3f1g27s5bkva0">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-584" data-mp="3tu9mdqvjdzl0">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-585" data-mp="3ovpyvm1aofqj"></path>
                  </svg>
                </div>
                Pentru cine este acest masterclass:
              </h3>
              <ul className="space-y-4" data-id="element-586" data-mp="3a4z6abrvpcmd">
                {['Antreprenori cu minimum 3 angajați care simt că totul depinde de ei și că echipa nu funcționează la potențial fără implicarea lor zilnică', 'Antreprenori care muncesc la fel de mult ca acum 2-3 ani dar cifra de afaceri nu mai crește și nu înțeleg de ce', 'Lideri de companie care vor să înțeleagă cum să construiască o afacere care funcționează cu sistem, nu cu energia lor personală'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-587" data-mp="3e6vibpldu9pw" data-mpi={i}>
                    <div className="w-2 h-2 rounded-full bg-[#1D4ED8] mt-2 flex-shrink-0" data-id="element-588" data-mp="3j55di073xabi"></div>
                    <span className="font-['Inter'] text-[17px] text-[#4B5563] leading-[1.6]" data-id="element-589" data-mp="3o6cl9z9929i6">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
            <div className="bg-[#FEF2F2] rounded-3xl p-8 border border-[rgba(239,68,68,0.2)]" data-id="element-590" data-mp="2vhoy1y4xxa1z">
              <h3 className="font-['Montserrat'] text-[24px] font-bold text-[#09111F] mb-6 flex items-center gap-3" data-id="element-591" data-mp="30gs0datjd269">
                <div className="w-8 h-8 rounded-full bg-[#EF4444] text-white flex items-center justify-center" data-id="element-592" data-mp="34fr4it7g0uwn">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-593" data-mp="399bv406pimlt">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" data-id="element-594" data-mp="2cpw3w0e4xiso"></path>
                  </svg>
                </div>
                Pentru cine nu este acest masterclass:
              </h3>
              <ul className="space-y-4" data-id="element-595" data-mp="249dlghowftph">
                {['Antreprenori la început de drum fără echipă, conținutul este relevant pentru afaceri care au deja oameni', 'Persoane care caută motivație și energie, nu un plan concret de acțiune bazat pe cifre și sistem', 'Antreprenori care nu sunt dispuși să pună în discuție modul în care conduc acum'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-596" data-mp="1qaxgav6oqb9g" data-mpi={i}>
                    <div className="w-2 h-2 rounded-full bg-[#EF4444] mt-2 flex-shrink-0" data-id="element-597" data-mp="1lidxnjt54pxs"></div>
                    <span className="font-['Inter'] text-[17px] text-[#4B5563] leading-[1.6]" data-id="element-598" data-mp="1giropmkchvus">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 7 — CTA FINAL */}
      <section id="oferta" className="w-full bg-[#F1F5F9] py-16 md:py-24 text-center scroll-mt-24" data-id="element-599" data-mp="12j8gktrjakih">
        <div className="max-w-[800px] mx-auto px-5 md:px-12" data-id="element-600" data-mp="2qfy819ciu4af">
          <h2 className="font-['Montserrat'] text-[32px] md:text-[40px] font-bold text-[#09111F] mb-4" data-id="element-601" data-mp="2qedenn1y0re5">
            Ești gata să ieși din plafonare?
          </h2>
          <p className="font-['Inter'] text-[19px] text-[#6B7280] mb-10" data-id="element-602" data-mp="2hf01ajap7io5">
            Rezervă-ți locul acum. Durează mai puțin de 1 minut.
          </p>
          <BookingButton text="Înscrie-te ACUM — Este GRATUIT" href="/contact" className="px-12 py-6 text-[18px] mb-4 shadow-[0_12px_30px_rgba(29,78,216,0.3)] inline-block" data-id="element-603" data-mp="27pyi6k8uwl5y" />
          <p className="font-['Inter'] text-[14px] text-[#09111F] font-medium" data-id="element-604" data-mp="2cirrllf9shod">
            Masterclass-ul este live, pe Zoom, o singură ediție. Locurile sunt
            limitate. Dacă te înscrii și nu poți participa live, primești
            înregistrarea pe email.
          </p>
        </div>
      </section>
    </div>;
}